import React, { useRef, useState, useEffect } from 'react'
import { documentations } from '@/constants';
import { ImageModal } from '../common/modal/ModalImage';
import { SectionContainerLight } from '../common/sections/SectionContainerLight';

export const SectionDocumentation = () => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedImageUri, setSelectedImageUri] = useState('');

    const [showLeft, setShowLeft] = useState(false);
    const [showRight, setShowRight] = useState(false);

    const scrollRef = useRef<HTMLDivElement | null>(null);

    const updateButtonsVisibility = () => {
        const container = scrollRef.current;
        if (!container) return;

        const { scrollLeft, scrollWidth, clientWidth } = container;
        setShowLeft(scrollLeft > 0);
        setShowRight(scrollLeft + clientWidth < scrollWidth - 1);
    };

    useEffect(() => {
        updateButtonsVisibility();
        const container = scrollRef.current;
        if (!container) return;

        container.addEventListener('scroll', updateButtonsVisibility);
        window.addEventListener('resize', updateButtonsVisibility);

        return () => {
            container.removeEventListener('scroll', updateButtonsVisibility);
            window.removeEventListener('resize', updateButtonsVisibility);
        };
    }, []);

    const scroll = (direction: string) => {
        const container = scrollRef.current;
        if (!container) return;

        const scrollAmount = 400;
        container.scrollBy({
            left: direction === 'left' ? -scrollAmount : scrollAmount,
            behavior: 'smooth'
        });
    };

    const showModal = (imageUri: string) => {
        setIsModalVisible(true);
        setSelectedImageUri(imageUri)
    };

    const hideModal = () => {
        setIsModalVisible(false);
        setSelectedImageUri('')
    };

    return (
        <SectionContainerLight id='documentations' additionalClassName='!py-2 !my-2'>
            <div className='flex flex-col mx-auto text-center items-center mb-4 md:mb-8'>
                <p className="text-black text-3xl md:text-4xl font-body font-semibold align-center -mt-2">Dokumentasi</p>
                <div className='border-2 md:border-4 border-accent-100 rounded-full w-40 mt-4 md:mt-6' />
            </div>
            <div className='relative flex justify-center'>
                <div className='w-full max-w-screen-xl relative flex items-center'>

                    {showLeft && (
                        <button
                            onClick={() => scroll('left')}
                            className='absolute left-0 w-10 h-10 flex items-center justify-center rounded-full bg-accelist-green hover:bg-accent-80 font-black shadow-md z-10'>
                            <img src="/img/home/left-arrow.png" alt="Kiri" />
                        </button>
                    )}

                    <div
                        ref={scrollRef}
                        className='flex overflow-x-auto space-x-4 md:space-x-8 lg:space-x-10 px-4 scrollbar-hide snap-x snap-mandatory w-full'
                    >
                        {documentations.map((e, i) => {
                            return (
                                <div key={i.toString()} className='snap-center flex-shrink-0 w-[320px] md:w-[335px] flex flex-col items-center justify-center border-2 border-gray-300 p-3 rounded-xl' >
                                    <div onClick={() => showModal(e.src)} className='w-full h-[210px] md:h-[225px] rounded-xl cursor-pointer'>
                                        <img src={e.src} alt={e.src} className={documentationsImageClassesStyle()} />
                                    </div>
                                    <p className='w-9/12 xs:w-7/12 text-lg sm:text-md md:text-base text-secondary-100 text-center font-body font-bold mt-2 xs:mt-1.5'>{e.description}</p>
                                </div>
                            )
                        })}
                    </div>

                    {showRight && (
                        <button
                            onClick={() => scroll('right')}
                            className='absolute right-0 w-10 h-10 flex items-center justify-center rounded-full bg-accelist-green hover:bg-accent-80 font-black shadow-md z-10'>
                            <img src="/img/home/right-arrow.png" alt="Kanan" />
                        </button>
                    )}

                </div>
            </div>
            <ImageModal imageUrl={selectedImageUri} hideModal={hideModal} isModalVisible={isModalVisible} />
        </SectionContainerLight>
    )
}

const documentationsImageClassesStyle = () => {
    return 'object-cover w-full h-full rounded-xl';
}
